import { Navigate, Route, Routes } from 'react-router-dom';
import { ParentCampsCatalogPage } from './ParentCampsCatalogPage';
import { ParentCampsRegisterPage } from './ParentCampsRegisterPage';
import { ParentCampsWaitlistPage } from './ParentCampsWaitlistPage';
import { ParentCampsRegistrationsPage } from './ParentCampsRegistrationsPage';

export function ParentCampsSourceFaithfulRoutes() {
  return (
    <Routes>
      <Route index element={<ParentCampsCatalogPage />} />
      <Route path=":campId/register" element={<ParentCampsRegisterPage />} />
      <Route path="waitlist" element={<ParentCampsWaitlistPage />} />
      <Route path="registrations" element={<ParentCampsRegistrationsPage />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
